import React from 'react';
import Skeleton from './Skeleton';
import { SKELETON_VARIANTS } from './constants';

const SkeletonField = ({ className = '' }) => {
  return (
    <div className={className}>
      <Skeleton variant={SKELETON_VARIANTS.TEXT} className="w-24 mb-2" />
      <Skeleton variant={SKELETON_VARIANTS.RECTANGULAR} className="h-10 w-full" />
    </div>
  );
};

export default SkeletonField;
